<!-- 

CONFIGURAÇÃO DE PAGAMENTOS ON LINE

-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';

export default {
    props: {
        parametros: { type: Object },
    },

    components: {
    },

    data () {
        return {
            editingClearsale: false,
            editingClearsaleObj: null,
        }
    },

    computed: {

    },

    filters: {

    },

    methods: {

        handleDesativar (operadora) {
            if (operadora == 'clearsale') {
                this.parametros.analisefraude.habilitaClearsale = false
            }
            this.$emit('saveconfig')
        },

        handleAtivar (operadora) {
            if (operadora == 'clearsale') {
                this.editingClearsale = true
                this.editingClearsaleObj = {...this.parametros.analisefraude.clearsale}
            }
        },

        handleSalvarClearsale () {
            this.parametros.analisefraude.habilitaClearsale = true
            this.editingClearsale = false
            this.$emit('saveconfig')
        },

        handleCancelarClearsale () {
            this.parametros.analisefraude.clearsale = this.editingClearsaleObj
            this.editingClearsale = false
            this.$emit('saveconfig')
        },

        handleEditClearsale() {
            this.editingClearsaleObj = {...this.parametros.analisefraude.clearsale}
            this.editingClearsale = true            
        },


    },

    watch: {

    },

    mounted () {

    },

    created () {

    }

}

</script>

<template>
  <div>
    <span class="lbl-deal-title mb-3">Análise de Fraude de Pagamento</span>
    <div class="row mb-2">
        <div class="col">
            <span>Configure as operadoras de Análise de Fraude de Pagamento da sua loja!</span>
        </div>
    </div>
    <div class="border p-3 mb-2">
        <!-- Clearsale -->
        <div class="row mb-2">
            <div class="col-12">
                <img src="clearsale.png" style="height: 30px">
                <span class="badge badge-success" v-if="parametros.analisefraude.habilitaClearsale">Ativado</span>
            </div>
        </div>
        <div class="row" v-if="!parametros.analisefraude.habilitaClearsale && !editingClearsale">
            <div class="col-md-12">
                <label class="lbl-edit">                    
                    Habilitar Análise de Fraude de Pagamentos através da operadora Clearsale 
                </label>
            </div>
            <div class="col-md-12">
                <v-button label="Ativar" :success="true" @click="handleAtivar('clearsale')"></v-button>
            </div>
        </div>
        <div class="row mt-3" v-if="parametros.analisefraude.habilitaClearsale || editingClearsale">
            <div class="col-md-6 col-12">
                <v-label label="Login"></v-label>
                <form-field key="clearsalelogin" v-model="parametros.analisefraude.clearsale.login" type="text" case="normal" :disabled="!editingClearsale"
                    data-toggle="tooltip" data-placement="top" title="Login para acesso ao Clearsale API."></form-field>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Senha"></v-label>
                <form-field ref="clearsalesenha" v-model="parametros.analisefraude.clearsale.senha" type="text" case="normal" :disabled="!editingClearsale"
                    data-toggle="tooltip" data-placement="top" title="Senha para acesso ao Clearsale API."></form-field>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Fingerprint (Seu_app)"></v-label>
                <form-field ref="clearsalefingerprint" v-model="parametros.analisefraude.clearsale.fingerprint" type="text" case="normal" :disabled="!editingClearsale"
                    data-toggle="tooltip" data-placement="top" title="Fingerprint (Seu_app) para acesso ao Clearsale API."></form-field>
            </div>

            <div class="col-md-12 mt-2" v-if="!editingClearsale">
                <v-label label="Seu link de Notificação Clearsale"></v-label>
                <div class="w-100"></div>
                <span class="badge badge-secondary">https://novo.notabrasil.com.br/ords/nbapp/clearsale/webhook/{{ parametros.codempresa }}</span>
            </div>
            <div class="col-md-12 mt-3" v-if="editingClearsale">
                <v-button label="Salvar" :success="true" @click="handleSalvarClearsale"></v-button>
                <v-button label="Cancelar" @click="handleCancelarClearsale"></v-button>
            </div>
            <div class="col-md-12 mt-3" v-if="parametros.analisefraude.habilitaClearsale && !editingClearsale">
                <v-button label="Desativar" :danger="true" @click="handleDesativar('clearsale')"></v-button>
                <v-button icon="fa-pencil" label="Editar" @click="handleEditClearsale"></v-button>
            </div>
        </div>
    </div>


  </div>

</template>

<style>


</style>



// WEBPACK FOOTER //
// src/forms-loja/config-analisefraude-form-loja.vue